/* eslint-disable */
const dictionary =
  require(`./../../clients/${process.env.CLIENT}/dictionary`).default;

//TODO: add in all languages and romove here!!
//dictionary.test = 'test';

export default dictionary;



// WEBPACK FOOTER //
// ./src/common/dictionary.js